import {Amount} from "@/model/amount";
import {WarriorClass} from "@/store/level/types";


export class ForceUpgrade {
    id!: number;
    warriorClass!: WarriorClass;
    updatingTill!: number;
}

export class ForceWithUpgrade {
    creatureId!: number;
    warriorClass!: WarriorClass;
    updatingTill!: number;
    level!:number
    canUpgrade!: boolean;
    minLevelMonster!: number;
}

export class ForceUpdateInfo {
    warriorClass!: WarriorClass;
    updateTimeSec!: number;
    amount!: Amount;
    canUpgrade!:boolean;

    updateOverCharge!: number;
    updatingTill!: number;
    speedupPrice!: number;

    currentLevel!: number;
    nextLevel!: number;
    maxLevel!: number;
    minMonsterLevel!: number;

    description!: string;
    diffDescription!: string;
}

